"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentFieldToJSON = exports.AttachmentFieldFromJSONTyped = exports.AttachmentFieldFromJSON = void 0;
function AttachmentFieldFromJSON(json) {
    return AttachmentFieldFromJSONTyped(json, false);
}
exports.AttachmentFieldFromJSON = AttachmentFieldFromJSON;
function AttachmentFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'value': json['value'],
    };
}
exports.AttachmentFieldFromJSONTyped = AttachmentFieldFromJSONTyped;
function AttachmentFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': value.value,
    };
}
exports.AttachmentFieldToJSON = AttachmentFieldToJSON;
//# sourceMappingURL=AttachmentField.js.map